/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Annual_Promo_LabelInputs */

const en_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`close annual promo`)
};

const id_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tutup promo tahunan`)
};

const ms_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tutup promosi tahunan`)
};

const ca_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tancar promoció anual`)
};

const cs_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zavřít promo nabídku ročního předplatného`)
};

const da_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luk kampagnen med årlig betaling`)
};

const de_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jährliche Werbeaktion beenden`)
};

const et_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sulge aastatellimuse reklaam`)
};

const es_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cerrar promoción de plan anual`)
};

const fr_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fermer la fenêtre`)
};

const hr_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zatvori promociju za godišnju pretplatu`)
};

const it_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi promozione annuale`)
};

const lv_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aizvērt ikgadējā maksājuma piedāvājumu`)
};

const lt_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`uždaryti metinį mokėjimo pasiūlymą`)
};

const hu_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`éves ajánlat lezárása`)
};

const nl_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jaaraanbieding sluiten`)
};

const nb_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lukk kampanjevindu`)
};

const pl_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zamknij roczną promocję`)
};

const pt_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fechar promoção anual`)
};

const ro_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`închide promoția anuală`)
};

const sk_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zavrieť ročné promo`)
};

const sl_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zaprite letno promocijo`)
};

const fi_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sulje vuositarjous`)
};

const sv_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`stäng årlig kampanj`)
};

const vi_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`đóng khuyến mãi hằng năm`)
};

const tr_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`yıllık promosyonu kapat`)
};

const el_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`κλείσιμο προσφοράς ετήσιας συνδρομής`)
};

const bg_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`затвори промоцията за годишен абонамент`)
};

const ru_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`закрыть годовую акцию`)
};

const sr_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`затвори промоцију за годишњу претплату`)
};

const uk_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`закрити щорічну акцію`)
};

const ka_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ყოველწლიური აქციის დახურვა`)
};

const hi_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एनुअल प्रोमो क्लोज करें`)
};

const th_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปิดโปรโมชั่นประจำปี`)
};

const ko_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연간 프로모션 종료`)
};

const zh_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭年度订阅促销`)
};

const zh_tw_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關閉年費方案優惠`)
};

const ja_close_annual_promo_label = /** @type {(inputs: Close_Annual_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年間プランのプロモーションを閉じる`)
};

/**
* | output |
* | --- |
* | "close annual promo" |
*
* @param {Close_Annual_Promo_LabelInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const close_annual_promo_label = /** @type {((inputs?: Close_Annual_Promo_LabelInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Annual_Promo_LabelInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_close_annual_promo_label(inputs)
	if (locale === "ms") return ms_close_annual_promo_label(inputs)
	if (locale === "ca") return ca_close_annual_promo_label(inputs)
	if (locale === "cs") return cs_close_annual_promo_label(inputs)
	if (locale === "da") return da_close_annual_promo_label(inputs)
	if (locale === "de") return de_close_annual_promo_label(inputs)
	if (locale === "et") return et_close_annual_promo_label(inputs)
	if (locale === "es") return es_close_annual_promo_label(inputs)
	if (locale === "fr") return fr_close_annual_promo_label(inputs)
	if (locale === "hr") return hr_close_annual_promo_label(inputs)
	if (locale === "it") return it_close_annual_promo_label(inputs)
	if (locale === "lv") return lv_close_annual_promo_label(inputs)
	if (locale === "lt") return lt_close_annual_promo_label(inputs)
	if (locale === "hu") return hu_close_annual_promo_label(inputs)
	if (locale === "nl") return nl_close_annual_promo_label(inputs)
	if (locale === "nb") return nb_close_annual_promo_label(inputs)
	if (locale === "pl") return pl_close_annual_promo_label(inputs)
	if (locale === "pt") return pt_close_annual_promo_label(inputs)
	if (locale === "ro") return ro_close_annual_promo_label(inputs)
	if (locale === "sk") return sk_close_annual_promo_label(inputs)
	if (locale === "sl") return sl_close_annual_promo_label(inputs)
	if (locale === "fi") return fi_close_annual_promo_label(inputs)
	if (locale === "sv") return sv_close_annual_promo_label(inputs)
	if (locale === "vi") return vi_close_annual_promo_label(inputs)
	if (locale === "tr") return tr_close_annual_promo_label(inputs)
	if (locale === "el") return el_close_annual_promo_label(inputs)
	if (locale === "bg") return bg_close_annual_promo_label(inputs)
	if (locale === "ru") return ru_close_annual_promo_label(inputs)
	if (locale === "sr") return sr_close_annual_promo_label(inputs)
	if (locale === "uk") return uk_close_annual_promo_label(inputs)
	if (locale === "ka") return ka_close_annual_promo_label(inputs)
	if (locale === "hi") return hi_close_annual_promo_label(inputs)
	if (locale === "th") return th_close_annual_promo_label(inputs)
	if (locale === "ko") return ko_close_annual_promo_label(inputs)
	if (locale === "zh") return zh_close_annual_promo_label(inputs)
	if (locale === "zh-tw") return zh_tw_close_annual_promo_label(inputs)
	if (locale === "ja") return ja_close_annual_promo_label(inputs)
	return en_close_annual_promo_label(inputs)
});